function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#FFF",
  width: 1200,
  height: 464,
  rx: 3
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "PxGroteskRegular, Px Grotesk",
  fontSize: 24
}, /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 65,
  fill: "#FF2955"
}, "export async function "), /*#__PURE__*/React.createElement("tspan", {
  x: 284.078,
  y: 65,
  fill: "#00DBB0"
}, "handleMemberRegistered"), /*#__PURE__*/React.createElement("tspan", {
  x: 566.441,
  y: 65,
  fill: "#000"
}, "(db: DB) {"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 97,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 68,
  y: 97,
  fill: "#A7AEB7"
}, "//Get event data"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 129,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 68,
  y: 129,
  fill: "#FF2955"
}, "const"), /*#__PURE__*/React.createElement("tspan", {
  x: 129.195,
  y: 129,
  fill: "#000"
}, " { AccountId, MemberId } "), /*#__PURE__*/React.createElement("tspan", {
  x: 406.367,
  y: 129,
  fill: "#4038FF"
}, "="), /*#__PURE__*/React.createElement("tspan", {
  x: 420.758,
  y: 129,
  fill: "#000"
}, " db."), /*#__PURE__*/React.createElement("tspan", {
  x: 461.68,
  y: 129,
  fill: "#4038FF"
}, "event.event_params"), /*#__PURE__*/React.createElement("tspan", {
  x: 686.633,
  y: 129,
  fill: "#000"
}, ";"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 193,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 68,
  y: 193,
  fill: "#FF2955"
}, "const"), /*#__PURE__*/React.createElement("tspan", {
  x: 129.195,
  y: 193,
  fill: "#000"
}, " member "), /*#__PURE__*/React.createElement("tspan", {
  x: 231.207,
  y: 193,
  fill: "#4038FF"
}, "="), /*#__PURE__*/React.createElement("tspan", {
  x: 245.598,
  y: 193,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 251.691,
  y: 193,
  fill: "#FF2955"
}, "new"), /*#__PURE__*/React.createElement("tspan", {
  x: 296.48,
  y: 193,
  fill: "#000"
}, " MemberRegistereds({ "), /*#__PURE__*/React.createElement("tspan", {
  x: 545.832,
  y: 193,
  fill: "#4038FF"
}, "accountId"), /*#__PURE__*/React.createElement("tspan", {
  x: 655.391,
  y: 193,
  fill: "#000"
}, ": AccountId."), /*#__PURE__*/React.createElement("tspan", {
  x: 791.621,
  y: 193,
  fill: "#00DBB0"
}, "toString"), /*#__PURE__*/React.createElement("tspan", {
  x: 880.379,
  y: 193,
  fill: "#000"
}, "(), "), /*#__PURE__*/React.createElement("tspan", {
  x: 907.871,
  y: 193,
  fill: "#4038FF"
}, "memberId"), /*#__PURE__*/React.createElement("tspan", {
  x: 1018.66,
  y: 193,
  fill: "#000"
}, ": +MemberId };"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 257,
  fill: "#A7AEB7"
}, " //Save to database."), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 289,
  fill: "#000"
}, " db."), /*#__PURE__*/React.createElement("tspan", {
  x: 102.828,
  y: 289,
  fill: "#00DBB0"
}, "save"), /*#__PURE__*/React.createElement("tspan", {
  x: 153.594,
  y: 289,
  fill: "#000"
}, "&lt;MemberRegistereds&gt;(member);"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 353,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 68,
  y: 353,
  fill: "#A7AEB7"
}, "//Query from datebase"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 385,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 68,
  y: 385,
  fill: "#FF2955"
}, "const"), /*#__PURE__*/React.createElement("tspan", {
  x: 129.195,
  y: 385,
  fill: "#000"
}, " m "), /*#__PURE__*/React.createElement("tspan", {
  x: 161.727,
  y: 385,
  fill: "#4038FF"
}, "="), /*#__PURE__*/React.createElement("tspan", {
  x: 176.117,
  y: 385,
  fill: "#000"
}), /*#__PURE__*/React.createElement("tspan", {
  x: 182.211,
  y: 385,
  fill: "#FF2955"
}, "await"), /*#__PURE__*/React.createElement("tspan", {
  x: 241.578,
  y: 385,
  fill: "#000"
}, " db."), /*#__PURE__*/React.createElement("tspan", {
  x: 282.5,
  y: 385,
  fill: "#00DBB0"
}, "get"), /*#__PURE__*/React.createElement("tspan", {
  x: 318.746,
  y: 385,
  fill: "#000"
}, "(MemberRegistereds, { "), /*#__PURE__*/React.createElement("tspan", {
  x: 574.379,
  y: 385,
  fill: "#4038FF"
}, "where"), /*#__PURE__*/React.createElement("tspan", {
  x: 640.883,
  y: 385,
  fill: "#000"
}, ": { "), /*#__PURE__*/React.createElement("tspan", {
  x: 668.609,
  y: 385,
  fill: "#4038FF"
}, "memberId"), /*#__PURE__*/React.createElement("tspan", {
  x: 779.398,
  y: 385,
  fill: "#000"
}, ": "), /*#__PURE__*/React.createElement("tspan", {
  x: 791.773,
  y: 385,
  fill: "#4038FF"
}, "123"), /*#__PURE__*/React.createElement("tspan", {
  x: 834.945,
  y: 385,
  fill: "#000"
}, " } });"), /*#__PURE__*/React.createElement("tspan", {
  x: 40,
  y: 417,
  fill: "#000"
}, "}")));

var SvgCommandJs = function SvgCommandJs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 464,
    viewBox: "0 0 1200 464"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgCommandJs as ReactComponent };